import { customerApi } from "../../utils/apiConfig";

//  Upload
export const uploadIsg = (userId, file, title, description, reminder) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("excel", file);

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");
    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30,
      })
    );
  }

  return customerApi.post("/uploadIsgDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

//  Update
export const updateIsg = (updatedId, userId, file, title, description, reminder) => {
  const formData = new FormData();
  formData.append("updatedId", updatedId);
  formData.append("userId", userId);
  formData.append("title", title);
  formData.append("description", description);

  if (file) {
    formData.append("excel", file);
  }

  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");
    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30,
      })
    );
  }

  return customerApi.post("/updateIsgDocument", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getIsg = () => {
  return customerApi.get("/getUploadIsgDocument", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const uploadIsgPersonel = (
  userId,
  personelData,
  reminder
) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("calismaDurumu", personelData.calismaDurumu || "");
  formData.append("ad", personelData.ad || "");
  formData.append("soyad", personelData.soyad || "");
  formData.append("tcNo", personelData.tcNo || "");
  formData.append("cinsiyet", personelData.cinsiyet || "");
  formData.append("dogumTarihi", personelData.dogumTarihi || "");
  formData.append("iseGirisTarihi", personelData.iseGirisTarihi || "");
  formData.append("yas", personelData.yas ?? "");
  formData.append("yasAraligi", personelData.yasAraligi || "");
  formData.append("firmaTehlikeSinifi", personelData.firmaTehlikeSinifi || "");
  formData.append("egitimDurumu", personelData.egitimDurumu || "");
  formData.append("gorev", personelData.gorev || "");
  formData.append('sertifika', personelData.sertifika || "")
  formData.append("isGuvenligiEgitim", personelData.isGuvenligiEgitim || "");
  formData.append("kkdZimmet", personelData.kkdZimmet || "");

  //  Hatırlatma varsa ekle
  if (reminder?.reminderActive) {
    formData.append("reminderActive", "true");
    formData.append(
      "reminder",
      JSON.stringify({
        startDate: reminder.startDate,
        endDate: reminder.endDate,
        note: reminder.note || "",
        notifyBefore: reminder.notifyBefore || 30,
      })
    );
  }

  return customerApi.post("/addIsgPersonel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getPersonelIsg = () => {
  return customerApi.get("/getIsgPersonel", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
